"use client";

import React from "react";
import { Dumbbell, PenTool, Building2, Wrench, Smile, Droplet } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesList = [{
  title: "COLON HYDROTHERAPY",
  description: "A gentle, non‑invasive colon cleansing treatment that helps eliminate toxins, improve digestion, and support overall gut health.",
  icon: Droplet
}, {
  title: "VITAMIN INJECTIONS + PEPTIDES",
  description: "Quick, potent nutrient and peptide support designed for immediate absorption, enhanced recovery, metabolic function, energy, performance, and overall wellness optimization.",
  icon: Dumbbell
}, {
  title: "ADVANCED LAB TESTING + NUTRITION\xA0",
  description: "Quick, potent nutrient and peptide support designed for immediate absorption, enhanced recovery, metabolic function, energy, performance, and overall wellness optimization. Our programs also include personalized nutrition support with customized meal prep and wellness plans, along with InBody body composition scans to assess progress, track measurable results, and help optimize your health journey.",
  icon: PenTool
}, {
  title: "WEIGHT LOSS + HORMONE OPTIMIZATION",
  description: "Weight Loss & Hormone Optimization combines advanced wellness strategies designed to support healthy weight management, metabolism, energy, hormone balance, and overall vitality. Our personalized programs may include GLP-based therapies, peptide support, comprehensive hormone optimization strategies, customized nutrition and meal planning, lifestyle guidance, body composition analysis, and targeted wellness support to help you achieve sustainable, measurable results and feel your best from the inside out.",
  icon: Building2
}, {
  title: "DETOX + RECOVERY",
  description: "Our Detox + Recovery services are designed to support relaxation, circulation, recovery, lymphatic flow, and overall wellness through advanced non-invasive therapies. Services may include infrared salt sauna therapy, ionic foot detox, PEMF, Amethyst Biomat therapy, vibration shake platform therapy, compression recovery, and lymphatic drainage support to help you feel refreshed, restored, and recharged.",
  icon: Wrench
}, {
  title: "Teeth Whitening Services",
  description: "Professional teeth whitening treatment to brighten your smile.",
  icon: Smile
}];
export default function OurSpecializedServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222157" id="our-specialized-treatments" className="bg-background text-foreground py-24 overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative rounded-lg overflow-hidden aspect-[4/5] lg:aspect-square group shadow-xl border border-border">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/inj.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/inj.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/inj.png-wvc-sizes" alt="Premium Vitamin Vials and Wellness Supplies" loading="lazy" className="object-cover w-full h-full transition-transform duration-1000 ease-out group-hover:scale-105" />
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/30 to-transparent pointer-events-none" />
          </div>

          {}
          <div className="flex flex-col gap-8">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-normal text-primary uppercase tracking-tight">
              Specialized Treatments
            </h2>

            <div className="flex flex-col gap-8">
              {servicesList.map((service, i) => {
              const Icon = service.icon;
              return <div key={i} data-index={i} className="flex items-start gap-6 group cursor-default">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg border border-primary/20 flex items-center justify-center text-primary transition-all duration-500 group-hover:bg-primary group-hover:text-primary-foreground group-hover:shadow-md">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div className="flex flex-col gap-2 pt-1">
                      <h3 className="text-xl font-default font-medium text-foreground uppercase tracking-wide">
                        {service.title}
                      </h3>
                      <p className="text-muted-foreground font-default text-base leading-relaxed">
                        {service.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}